export default __webpack_public_path__ + "static/media/aldemat_navicon-light.00d6843b.svg";